import { PostDestination, PostDestinationType, ErrorResponse, LegacyPage } from '../types'
import { BRAND_FACEBOOK } from '../constants'
import { assert } from '../utils'

export function destinationAdapter(page: LegacyPage): PostDestination {
  const network = page.typeText as PostDestinationType
  const token = page.token
  let image = page.picture
  if (network === BRAND_FACEBOOK) {
    image += `&access_token=${token}`
  }

  const id = page.networkId.toString()

  return {
    id,
    type: network,
    idNew: `${page.type}_${page.networkId}`,
    image,
    ppid: page.ppPageId.toString(),
    name: page.pageName || page.username || id || '',
    connected: !!+page.connected,
    default: !!+page.default,
    fbGroup: page.type?.toString() === '2',
    isLinkedinPersonalProfile: page.type?.toString() === '5',
    token,
    tokenV2: page.tokenV2,
    isMigrated: !!page.isMigrated,
    ownedBy: page.ownedBy?.toString(),
    ownerId: page.ownerId?.toString(),
    publishBy: page.publishBy?.toString(),
    ppPublishBy: page.ppPublishBy?.toString(),
    extraAdmin: Boolean(page.extraAdmin)
  }
}

export function destinationsAdapter(response: LegacyPage[] | ErrorResponse): PostDestination[] {
  const pagesResponse = assert<LegacyPage[]>(response)
  return pagesResponse.map(destinationAdapter)
}
